import script from "./SwitchAccountDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchAccountDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./SwitchAccountDropdown.vue?vue&type=style&index=0&id=2c16b372&lang=scss&scoped=true"
import "./SwitchAccountDropdown.vue?vue&type=style&index=1&id=2c16b372&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c16b372"]])

export default __exports__